import React, { useState } from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Axios from "axios";

//STYLES
import * as CheckoutStyles from "../../styles/basket/checkout";

function PaymentIntent(props) {
    const stripe = useStripe();
    const elements = useElements();
    const user = useSelector((state) => state.user);
    const printingShop = useSelector((state) => state.printingShop);
    const [isProcessing, setIsProcessing] = useState(false);

    async function handleBuyNowClick() {
        const items = [];
        for (const item of printingShop.items) {
            items.push({
                basketUUID: item.uuid,
                itemUUID: item.productDetails.uuid,
                priceStatus: item.priceStatus,
                quantity: item.quantity
            });
        }

        const data = {
            userID: user.id,
            userDetails: printingShop.checkoutFormData.values,
            postageActive: printingShop.postageActive,
            postageUUID: printingShop.selectedPostage,
            couponSuccess: props.couponDetails.success,
            couponUUID: printingShop.couponUUID,
            items: items,
            paymentIntentID: props.paymentIntentID
        };

        Axios.post("/pods/3dprintingShop/checkout/processCheckout", data)
            .then(async (res) => {
                const data = res.data;
                if (data.error == "null") {
                    if (!stripe || !elements) {
                        return;
                    }
                    setIsProcessing(true);
                    const { error } = await stripe.confirmPayment({
                        elements,
                        confirmParams: {
                            return_url: `${window.location.origin}/processOrder`
                        }
                    });
                    if (error) {
                        console.log(error.message);
                    }
                    setIsProcessing(false);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <PaymentElement />
            <Button disabled={isProcessing} variant="success" style={CheckoutStyles.checkoutButton} onClick={handleBuyNowClick}>
                Buy now
            </Button>
        </div>
    );
}

export default PaymentIntent;
